import { Record } from '@/domains/work';
import { Question, Option } from '@/domains/template';

/**
 * 档案Excel
 */
export default class TemplatesExcelUtil {
  /**
   * 转换至Excel数据
   *
   * @param datas 听课档案列表
   * @param headers 表头
   */
  protected static toExccelData(datas: Record[], headers: string[]) {
    const list: any[] = [];

    datas.forEach((record: Record, index: number) => {
      // 获取问题列表
      const questions: Question[] = record.template.questions;

      const data: any[] = [];

      // 设置表头
      if (index === 0) {
        this.setHeaders(questions, headers);
      }

      // 设置听课记录表编号
      data.push(record.id);
      data.push(record.plan.supervisor.person.name);

      // 遍历答案
      this.setQuestion(questions, data);

      data.push(record.sumScore);
      data.push(record.useTime);
      data.push(record.plan.supervisor.supervisorGroup.fullName);
      data.push(record.statusValue);
      data.push(record.rejection);
      data.push(record.plan.coursePlan.clazz.course.id);

      data.push(record.month ? record.month.month : '');
      data.push(record.confirmTimeFormat);
      data.push(record.ip);
      data.push(record.source);
      data.push('');
      data.push('');
      data.push('');
      data.push('');
      data.push('');
      data.push(record.courseFormName);
      list.push(data);
    });
    return list;
  }

  /** 表头 */
  private static START_HEADERS: string[] = ['档案编号', '督导姓名'];

  /** 表头 */
  private static END_HEADERS: string[] = [
    '总分',
    '使用时间',
    '督导分组',
    '状态',
    '驳回原因',
    '课程代码',
    '月份',
    '提交时间',
    'ip',
    '来源',
    '邮箱反馈',
    '暂未反馈',
    '学生讨论汇报',
    '教师讲授+学生讨论汇报',
    '其他',
    '开课形式',
  ];

  /** 设置表头 */
  private static setHeaders(questions: Question[], headers: string[]) {
    this.START_HEADERS.forEach((header: string) => {
      headers.push(header);
    });
    this.setQuestionHeader(questions, headers, false);
    this.END_HEADERS.forEach((header: string) => {
      headers.push(header);
    });
  }

  /** 设置问题标题 */
  private static setQuestionHeader(questions: Question[], headers: string[], setTitle: boolean) {
    questions.forEach((question: Question) => {
      const subQuestions: Question[] = question.questions;
      if (subQuestions !== null) {
        if (setTitle) {
          headers.push(question.base.name);
        }
        this.setQuestionHeader(subQuestions, headers, question.type.id === 6);
      } else {
        if (question.base.id !== 95) {
        headers.push(question.base.name);
        }
      }
    });
  }

  private static setQuestion(questions: Question[], data: any[]) {
    questions.forEach((question: Question) => {
      switch (question.type.id) {
        case 1:
          this.setSingleSelect(question, data);
          break;
        case 2:
          this.setMultiSelect(question, data);
          break;
        case 4:
          this.setSingleInput(question, data);
          break;
        case 5:
          this.setMultiInput(question, data);
          break;
        case 6:
          this.setMultiQuestion(question, data);
          break;
      }
    });
  }

  /** 设置单选题 */
  private static setSingleSelect(question: Question, data: any[]): void {
    // const answer: string = question.answer.answer;
    // const options: Option[] = question.options;
    // const result: boolean = options.some(
    //   (option: Option): boolean => {
    //     if (option.value === answer) {
    //       data.push(option.base.name);
    //       return true;
    //     }
    //   },
    // );
    // if (!result) {
    //   data.push('');
    // }
    const answer: string = question.answer.answer;
    const options: Option[] = question.options;
    let answerDetail: string = '';
    options.forEach((option: Option) => {
      if (option.value === answer) {
        answerDetail = answerDetail + option.base.name;
      }
    });
    if (question.answer.other != null) {
      answerDetail = answerDetail + question.answer.other;
    }
    data.push(answerDetail);
  }

  /** 设置单行填空题 */
  private static setSingleInput(question: Question, data: any[]): void {
    question.questions.forEach((sub: Question) => {
      const answer: string = sub.answer.answer;
      if (sub.base.id !== 95) {
      data.push(answer);
      }
    });
  }

  /** 设置多行填空题 */
  private static setMultiInput(question: Question, data: any[]): void {
    question.questions.forEach((sub: Question) => {
      const answer: string = sub.answer.answer;
      data.push(answer);
    });
  }

  /** 设置多选题 2019/3/20 */
  private static setMultiSelect(question: Question, data: any[]): void {
    const answer: string = question.answer.answer || '';
    const options: Option[] = question.options;
    const answerDetail: string[] = [];
    options.forEach((option: Option) => {
      if (answer.indexOf(option.value) > -1 ) {
        answerDetail.push(option.base.name);
      }
    });
    data.push(answerDetail.join('，'));
  }

  /** 设置矩阵题 */
  private static setMultiQuestion(question: Question, data: any[]): void {
    question.questions.forEach((sub: Question) => {
      const answer: string = sub.answer.answer;
      data.push(answer);
      const childs: Question[] = sub.questions;
      if (childs && childs.length) {
        childs.forEach((child: Question) => {
          this.setSingleSelect(child, data);
        });
      }
    });
  }
}
